/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PerformanceStat {
  serviceName?: string;
  serviceInstance?: number;
  code?: string;
  time?: string;
  min?: number;
  max?: number;
  total?: number;
  count?: number;
  avg?: number;
}
